export const PATH = '/api/v1/'


// WEBPACK FOOTER //
// ./src/webapiPath.js